var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-wrapper"},[(_vm.switch_tab == 'accounts')?_c('Accounts',{attrs:{"filter":_vm.accountPageFilter},on:{"tab":(value) => {
      _vm.selectTab(value);
    },"onFilter":(data) => _vm.accountPageFilter = data}}):_vm._e(),(_vm.switch_tab == 'account_contacts')?_c('AccountContacts',{attrs:{"filter":_vm.accountContactPageFilter},on:{"tab":(value) => {
      _vm.selectTab(value);
    },"onFilter":(data) => _vm.accountContactPageFilter = data}}):_vm._e(),(_vm.switch_tab == 'lia_contacts')?_c('LIAContacts',{attrs:{"filter":_vm.liaContactPageFilter},on:{"tab":(value) => {
      _vm.selectTab(value);
    },"onFilter":(data) => _vm.liaContactPageFilter = data}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }